exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-label-left {\n  flex: 0 0 50%;\n  text-align: left;\n}\n.card {\n  border-radius: 5px;\n}\n", ""]);

// exports
